import { createSelector } from '@reduxjs/toolkit';

import { LinkData } from 'src/containers/ProjectDiagram/types/model';
import { entityDrawerSelector } from 'src/selectors/entityDrawer';
import { projectLinkDataArraySelector } from 'src/selectors/projectLinkDataArray';

export const entityDrawerLinkDataSelector = <T extends LinkData>(
  projectId: string,
  isType: (data: any) => data is T
) =>
  createSelector(
    entityDrawerSelector,
    projectLinkDataArraySelector(projectId),
    (drawer, linkDataArray) =>
      linkDataArray.find(
        (linkData): linkData is T =>
          isType(linkData) && linkData.value === drawer.entityValue
      ) || null
  );
